var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockSolid = function SvgLockSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.125a3.54 3.54 0 0 1 3.542 3.542l-.001 1.416h.31c.631 0 .86.066 1.091.19.23.123.412.304.535.535.124.23.19.46.19 1.091v4.16c0 .631-.066.86-.19 1.091a1.3 1.3 0 0 1-.535.536c-.23.123-.46.189-1.091.189H4.649c-.631 0-.86-.066-1.09-.19a1.3 1.3 0 0 1-.536-.535c-.124-.23-.19-.46-.19-1.091v-4.16c0-.631.066-.86.19-1.09.123-.232.304-.413.535-.536s.46-.19 1.091-.19h.309V5.667A3.54 3.54 0 0 1 8.5 2.125m0 1.417a2.125 2.125 0 0 0-2.125 2.125v1.416h4.25V5.667A2.125 2.125 0 0 0 8.5 3.542"
  })));
};
export default SvgLockSolid;